<template>
  <v-container v-if="$auth.check()">
    <v-row>
      <v-col>
        <div class="d-flex justify-space-between">
          <h1>{{ $t('texts.jobTitle') }}</h1>
          <v-btn
            color="primary"
            class="white--text"
            :to="{ name: 'company.jobs.create' }"
          >
            {{ $t('texts.newJob') }}
            <v-icon class="white--text" right>add_circle_outline</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <missing-information/>
    <subscription-required/>
    <v-row>
      <v-col>
        <v-card>
          <v-tabs
            v-model="active"
            slider-color="primary"
            color="transparent"
            active-class="text--primary"
          >
            <v-tab
              ripple
              :to="{ path: `/company/${company.id}/jobs/list/active` }"
            >
              {{ $t('texts.active') }}
            </v-tab>
            <v-tab
              ripple
              :to="{ path: `/company/${company.id}/jobs/list/draft` }"
            >
              {{ $t('texts.draft') }}
            </v-tab>
            <v-tab
              ripple
              :to="{ path: `/company/${company.id}/jobs/list/archived` }"
            >
              {{ $t('texts.archived') }}
            </v-tab>
            <v-tabs-items v-model="active">
              <v-card>
                <v-card-text>
                  <router-view/>
                </v-card-text>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import MissingInformation from '@/components/_templates/company/profile/MissingInformation.vue';
import SubscriptionRequired from '@/components/_organisms/company/SubscriptionRequired.vue';

const { mapState: mapCompanyProfileState, mapActions: mapCompanyProfileActions } = createNamespacedHelpers('company/profile');

export default {
  name: 'CompanyJobs',
  components: {
    MissingInformation,
    SubscriptionRequired,
  },
  data() {
    return {
      active: null,
    };
  },
  created() {
    this.checkCompanyProfile({
      companyId: this.selectedCompanyId,
    });
  },
  computed: {
    ...mapCompanyProfileState([
      'company',
      'missingInformation',
    ]),
    selectedCompanyId() {
      return this.$route.params.companyId;
    },
    showInspectingJobs() {
      return this.$route.meta.listType === 'active';
    },
  },
  methods: {
    ...mapCompanyProfileActions([
      'checkCompanyProfile',
    ]),
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep {
    .v-tabs__item--active {
      color: #0d5890;
    }
  }
</style>
